// Keeps the top-level main nav to a single row on desktop: instead of
// letting extra links wrap to a second row (which pushes the promo bar and
// hero down unpredictably — see tasks/lessons.md), any links that don't fit
// get moved into a trailing "More ▾" flyout. .main-nav itself is set to
// `flex-wrap: nowrap` (main.css) so this script is the only thing standing
// between "too many links" and links silently overflowing off-screen — if
// this script fails to run for any reason, nothing hides, so the nowrap
// row will just visually overflow rather than wrap; that's an acceptable,
// rare degrade next to the far more common "one extra link wraps the whole
// header" case this replaces.
(function () {
  function init() {
    const nav = document.querySelector('.main-nav');
    const moreItem = document.querySelector('.main-nav__more');
    const moreList = document.querySelector('.main-nav__more-list');
    if (!nav || !moreItem || !moreList) return;

    const items = Array.prototype.filter.call(nav.children, (li) => li !== moreItem);
    if (!items.length) return;

    function measure() {
      // Reset every real item and empty the flyout before re-measuring —
      // otherwise growing the viewport back out after a shrink would stay
      // stuck with whatever was hidden at the narrowest point.
      items.forEach((li) => { li.hidden = false; });
      moreItem.hidden = true;

      // Below md, .main-nav renders as a plain vertical list (main.css's
      // own max-width: 768.98px block sets .main-nav__item to display:
      // block; width: 100%) — every item already gets its own full-width
      // row there, so "does this fit in one row" isn't a real question to
      // ask on mobile the way it is for the desktop horizontal bar this
      // script exists for. Answering it anyway hid every single item
      // behind "More" on mobile, since nothing at a phone's width was ever
      // going to sum to less than the full row of link text. The early
      // return above already reset everything to visible/no-More, so
      // bailing here just leaves that reset in place.
      if (!theme.mediaMatches.md) return;

      const navWidth = nav.clientWidth;
      const fullWidth = items.reduce((sum, li) => sum + li.offsetWidth, 0);
      if (fullWidth <= navWidth) {
        moreList.innerHTML = '';
        return;
      }

      // Only reveal the "More" trigger once we know it's actually needed —
      // its own width has to count against the available budget too, but
      // only in the branch where something is really going to end up
      // inside it (see the early return above for the common, fits-fine
      // case).
      moreItem.hidden = false;
      const budget = navWidth - moreItem.offsetWidth;

      // Read every item's width in one batched pass *before* writing any
      // `hidden` — hiding li[0] doesn't change li[1..n]'s own intrinsic
      // width in a plain nowrap flex row, but it does dirty layout, so
      // reading li[1].offsetWidth on the next loop iteration would force a
      // synchronous recalc for a value that was never actually going to
      // change. Splitting into a read-only .map() then a write-only
      // .forEach() over the same pre-computed widths avoids that
      // read/write interleaving entirely.
      const widths = items.map((li) => li.offsetWidth);
      let used = 0;
      const overflowed = [];

      items.forEach((li, i) => {
        if (overflowed.length || used + widths[i] > budget) {
          li.hidden = true;
          overflowed.push(li);
        } else {
          used += widths[i];
        }
      });

      moreList.innerHTML = '';
      overflowed.forEach((li) => {
        const link = li.querySelector(':scope > a, :scope > details > summary > a');
        if (!link) return;
        const listItem = document.createElement('li');
        const anchor = document.createElement('a');
        anchor.className = 'child-nav__item main-nav__item';
        anchor.href = link.href;
        anchor.textContent = link.textContent.trim();
        listItem.appendChild(anchor);
        moreList.appendChild(listItem);
      });
    }

    new ResizeObserver(measure).observe(nav);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
